import React, { useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";

import "./PayFreequency.scss";
import Progress from "../../../components/Progress/Progress";
import ScrollToTop from "../../../components/ScrollToTop/ScrollToTop";
import { StepPreFooter } from "../../../components/Footer/StepPreFooter";

import PayFreequencyIcon from "../../../assets/images/step-icon/PayFreequency-icon.png";
import checkedIcon from "../../../assets/images/checked.png";

import { updateContact } from "../../../redux/apiCalls";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { useForm } from "react-hook-form";
import { Box } from "@mui/material";
import { StepBtn } from "../../../components/Button/StepBtn/StepBtn";
import { payFrequencyOptions } from "../../../utils/options";
import { nextStepDelayTime } from "../../../utils/const";
import { getPrevStepLink } from "utils/functions";

const PayFreequency = () => {
  const contactRedux = useSelector((state) => state?.contact?.contact);
  const [incomePaymentFrequency, setPayFrequency] = useState(
    contactRedux?.incomePaymentFrequency ?? ""
  );
  const [loadingButton, setLoadingButton] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const windowWidth = window.innerWidth;
  const isMobile = windowWidth < 768;

  const currentLoc = useLocation();
  const prevLink = getPrevStepLink(currentLoc.pathname);

  // custom
  const {
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm();
  const onSubmit = async (value) => {
    if (!incomePaymentFrequency) {
      setError("incomePaymentFrequency", {
        type: "error",
        message: "Please choose an answer"
      });
      return;
    }

    if (loadingButton) {return}
    setLoadingButton(true);

    const lead_id = sessionStorage.getItem("lead_id");
    const res = await updateContact(dispatch, contactRedux?._id, {
      step: 12,
      lead_id,
      incomePaymentFrequency: incomePaymentFrequency
    });

    if (res?.status === 200) {
      setTimeout(() => {
        setLoadingButton(false);
        navigate("/grossincome");
      }, nextStepDelayTime);
    }
  };

  return (
    <Box className="PayFreequency-page">
      <Navbar />
      <ScrollToTop />
      <Box
        sx={{
          width: "100%",
          maxWidth: "700px",
          margin: "20px auto"
        }}
      >
        <div className="step-main">
          <form className="step-form" onSubmit={handleSubmit(onSubmit)}>
            <Box
              sx={{
                width: "100%",

                margin: "10px auto 30px",
                padding: isMobile && "0 15px"
              }}
            >
              <Progress step={11} />
            </Box>
            <Box sx={{ textAlign: "center", marginBottom: "11px" }}>
              <img
                style={{
                  maxWidth: isMobile && "42px"
                }}
                src={PayFreequencyIcon}
                alt=""
              />
            </Box>
            <h2 className="title">Pay Frequency</h2>
            <h5>How many times a month do you get paid?</h5>

            <div className="form-control">
              <div className="list-btn-radio">
                {payFrequencyOptions.map((option, index) => (
                  <button
                    key={index}
                    className={`btn-radio ${
                      incomePaymentFrequency === option.value ? "active" : ""
                    }`}
                    onClick={() => {
                      setPayFrequency(option.value);
                      clearErrors("incomePaymentFrequency");
                    }}
                  >
                    {option.label}
                    {incomePaymentFrequency === option.value && (
                      <img className="checked-icon" src={checkedIcon} alt="" />
                    )}
                  </button>
                ))}
              </div>

              {errors?.incomePaymentFrequency && (
                <span style={{
                  color: "red",
                  fontSize: "12px",
                  marginBottom: "10px",
                  display: "block",
                  textAlign: "center"
                }} className="error">{errors?.incomePaymentFrequency?.message}</span>
              )}
            </div>

            <Box
              sx={{
                maxWidth: "474px",
                margin: "0 auto"
              }}
            >
              <StepBtn
                prevLink={prevLink}
                onSubmit={handleSubmit(onSubmit)}
                loading={loadingButton}
              />
            </Box>
          </form>
          <StepPreFooter />
        </div>
      </Box>

      {/* <Footer desc={false} /> */}
    </Box>
  );
};

export default PayFreequency;
